import { render, staticRenderFns } from "./workHours.vue?vue&type=template&id=c187c6aa&scoped=true"
import script from "./workHours.vue?vue&type=script&lang=js"
export * from "./workHours.vue?vue&type=script&lang=js"
import style0 from "./workHours.vue?vue&type=style&index=0&id=c187c6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c187c6aa",
  null
  
)

export default component.exports